import { MousePointerClick } from 'lucide-react'

export function EmptyDetailPlaceholder() {
  return (
    <div className="flex flex-col items-center justify-center h-full gap-2 text-gray-400">
      <MousePointerClick size={32} strokeWidth={1.5} />
      <p className="text-sm">Velg en ordre fra tabellen</p>
    </div>
  )
}
